import { render, staticRenderFns } from "./SpecialistDashboardInsights.vue?vue&type=template&id=502f91e7&scoped=true&"
import script from "./SpecialistDashboardInsights.vue?vue&type=script&lang=js&"
export * from "./SpecialistDashboardInsights.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistDashboardInsights.vue?vue&type=style&index=0&id=502f91e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502f91e7",
  null
  
)

export default component.exports